export default __webpack_public_path__ + "static/media/mr-hero.416e01c5.png";